module.exports = __webpack_public_path__ + "resources/close-circle-filled-2b9a0857fab14be609033792b5c21013.svg";